import { DRAWING_STYLE } from '../../styles';
import { DomCircleOverlay } from './DomCircleOverlay';

/**
 * 创建绘制过程中的顶点圆点
 *
 * DOM 覆盖物实现（非 Marker），创建即渲染，
 * 避免 WebGL Marker 重绘延迟导致的「单击不画圆 / 圆点慢一拍」。
 *
 * @param fill 圆点填充色，默认使用 DRAWING_STYLE.point.fill
 */
export function createDrawingPointOverlay(map: any, point: any, fill?: string) {
  const { size, border, boxShadow } = DRAWING_STYLE.point;
  // border 形如 '2px solid #ffffff'，拆出宽度与颜色
  const borderWidth = parseInt(border, 10) || 0;
  const borderColor = border.split(' ').pop() ?? '#ffffff';

  const circle = new DomCircleOverlay(point, {
    size: size + borderWidth * 2,
    background: fill ?? DRAWING_STYLE.point.fill,
    borderWidth,
    borderColor,
    boxShadow,
    className: 'drawing-vertex-point',
  });
  const overlay = circle.mount(map);

  return {
    overlay,
    setPosition: (nextPoint: any) => {
      circle.setPosition(nextPoint);
    },
    remove: () => {
      circle.remove(map);
    },
  };
}
